import { render, staticRenderFns } from "./TeacherCatPage.vue?vue&type=template&id=84c622ec&scoped=true&"
import script from "./TeacherCatPage.vue?vue&type=script&lang=js&"
export * from "./TeacherCatPage.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCatPage.vue?vue&type=style&index=0&id=84c622ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c622ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VProgressCircular,VRow})
